import { render, staticRenderFns } from "./UserManagementSync.vue?vue&type=template&id=27db329c&scoped=true"
import script from "./UserManagementSync.vue?vue&type=script&lang=js"
export * from "./UserManagementSync.vue?vue&type=script&lang=js"
import style0 from "./UserManagementSync.vue?vue&type=style&index=0&id=27db329c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27db329c",
  null
  
)

export default component.exports